import apiUrl from './../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
//import VueElementLoading from 'vue-element-loading';
import {BasicSelect,  MultiSelect} from 'vue-search-select'
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import TripServices from './../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import Loader from './../../../shared/components/loader'
import Treeselect from '@riophae/vue-treeselect';
import iptracker from '../../../../views/components/commonfunction/iptracker';
import Multiselect from 'vue-multiselect'
export default {
  name: 'ShiftShipmentDestinationHub',
  components: {
    //VueElementLoading,
    Treeselect, 
    Paginate,
    BasicSelect,
    TripServices,
    TripServices,
    vueMultiSelect,
    iptracker,
    Loader,
    Multiselect
  },
  data: function() {
    return {
      shipmentId: '',
      awbErr:'',
      finaldestination: '',
      comments: '',
      commenterr: '',
      isLoading:false,
      selectedOrigin:{value:'',text:''},
      HubList: [],
      huberr: '',
      userdetail: {},
      awbarr: []

    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userdetail = userdetail;
    this.userName = userdetail.email;
    this.getHublist();
  },
  methods: {
    selectOrigin(data){
      this.selectedOrigin = data;
      this.finaldestination = data.value;
    },
    async getHublist() {
      try {
        let InputPayload = {};
        let result = await TripServices.GetHublist(InputPayload);
        let hublist = result.data.data.data;
        for (var i = 0; i < hublist.length; i++) {
          this.HubList.push({
          'value': hublist[i].HubID,
          'text': hublist[i].HubName
          });
        }
        // return HubList;
      } catch (err) {
        console.log(err);
      }
    },
    async updatedestinationhub() {
      try {
        if(this.checkErr()){
          return false
        }
        this.commenterr = ''
        this.huberr = ''
        this.awbErr = ''
        this.isLoading = true
        let inputPayload = {
          awbarray : this.awbarr[0],
          comments : this.comments,
          lastmodifiedby: this.userName
        }
        if(this.finaldestination)
        {
          inputPayload.destinationhubid = this.finaldestination.value.toString()
        }
        let result = await TripServices.UpdateDestinationHub(inputPayload)
        if(result.status == 200){
          if(result.data.data.failurearr.length>0) {
            this.shipmentId == ''
            let awb = []
            result.data.data.failurearr.forEach(element => {
              this.awbarr = []
              awb.push(element.awb)
              this.$alertify.error(`${element.awb} : ${element.err}`)
            });
            this.shipmentId = awb.toString(); 
          }
          if(result.data.data.failurearr.length == 0) {
            this.reset()
          }
          if(result.data.data.success.length>0) {
            this.$alertify.success("Destination Hub Successfully Updated")
          }
          console.log("this.awbarr", this.awbarr, inputPayload);
          this.getTraceIP(inputPayload)
          this.isLoading = false
        }
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmitSearch() {
      try {
      this.updatedestinationhub()
      } catch (err) {
        console.log(err);
      }
    },
    checkErr(){
      let err = false
      if(this.shipmentId == ''){
        err=true
        this.awbErr = 'Please Enter Shipment ID(s)'
      }
      else if(!this.shipmentId.match(/^([a-z0-9\s]+,)*([a-z0-9\s]+){1}$/i) || this.shipmentId.indexOf(" ")>=0){
        err = true
        this.awbErr = 'Please follow the correct format'
      }
      this.awbarr.push(this.shipmentId.split(','))
      if(this.awbarr[0].length>=15) {
        err = true
        this.awbErr = 'Maximum 15 AWBs allowed'
      }
      if(!this.finaldestination) {
        err = true
        this.huberr = 'Please select Destination hub'
      }
      if(this.comments == '') {
        err = true
        this.commenterr = 'Please enter comments'
      }
      if(this.comments.length > 500) {
        err = true
        this.commenterr = 'Maximum 500 characters allowed'
      }
      return err
    },
    getTraceIP(data) {
      let payload = 
        {
          "projectname": this.userdetail.project,
          "type": "web",
          "userid": this.userdetail.userid,
          "username": this.userdetail.username,
          "routeurl":'/ShiftShipmentDestinationHub',
          "meta" : {
            "event" : `Shift Shipment Destination Hub`,
            "data" : data
          }
      }
      let result = iptracker.getTraceIP(payload);
    },
    reset() {
      this.shipmentId = '',
      this.awbErr = '',
      this.huberr = '',
      this.finaldestination = '',
      this.selectedOrigin = {value:'',text:''},
      this.awbarr = [],
      this.commenterr = ''
      this.comments = ''
    }
    // onSubmit: function(event) {
    //   this.$validator.validateAll().then((result) => {
    //     if(result){
    //       this.createServiceArea(event);
    //     }
    //   }).catch(() => {
    //     console.log('errors exist', this.errors)
    //   });
    // },
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/ShiftShipmentDestinationHub/ShiftShipmentDestinationHub.component.js